import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import {
    TableContenForLoftSummaryReport
} from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { LoftSummaryReportSchemaObject } from "../loftSummarySchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import moment from 'moment';

const screenCode = "LOFTDEDUCTIONREPORT";

export function LoftSummaryReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);

    const [leafCollectionVariance, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        fromDate: "",
        toDate: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        fromDate: "",
        toDate: ""
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(LoftSummaryReportSchemaObject).options({ allowUnknown: true });
    const initialContentRownames = ["collectionPointName", "bagCount"];

    const [contentRowNames, setContentRowNames] = useState([]);
    const [columnNames, setColumnNames] = useState([]);

    const initialCsvHeaders = [
        { label: "Route Name", value: "collectionPointName" },
        { label: "Bag Count", value: "bagCount" },
    ]
    const [csvHeaders, setCsvHeaders] = useState([]);

    const [reportData, setReportData] = useState([]);
    const [fullTotalRow, setFullTotalRow] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [bagCount, setBagCount] = useState(0);
    const [deductionIds, setDeductionIds] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionVariance.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionVariance.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"
        });
        setIsTableHide(true);
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            factoryID: target.value,
            routeID: "0"
        });
        setIsTableHide(true);
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            routeID: target.value
        });
        setIsTableHide(true);
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            fromDate: target.value,
        });
        setIsTableHide(true);
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            toDate: target.value,
        });
        setIsTableHide(true);
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, LoftSummaryReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWLOFTDEDUCTIONREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionVariance.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionVariance.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, leafCollectionVariance);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionVariance);

        const result = await services.getLoftDedcutionSummaryData(leafCollectionVariance);

        var finalResult = mergeResultData(result);

        var contentResult = generateTableInitializationData(result.loftData);

        var totalRowResult = calculateTotal(finalResult);

        if (finalResult.length > 0) {
            setIsTableHide(false);
            setReportData(finalResult);
            createDataTable(contentResult, ["#leafCollectionSummary", "#leafCollectionSummaryPdf"]);

            generateCsvData(finalResult, totalRowResult, contentResult);
        }
    }

    function mergeResultData(data) {
        var mergedData = [];
        var bagCountBYCp = [];

        data.loftData.forEach(x => {
            if (mergedData.length === 0) {
                mergedData.push(createRecord(x));
            } else {
                var duplicateRec = mergedData.find(y => y.collectionPointID === x.collectionPointID);

                if (duplicateRec) {
                    if (x.loftDeductionTempId !== null) {
                        duplicateRec[x.loftDeductionTempId] = checkIsUndefined(duplicateRec[x.loftDeductionTempId])
                            + checkIsUndefined(x.loftDeductionAmount);
                    }
                } else {
                    mergedData.push(createRecord(x));
                }
            }
        });

        data.bagData.forEach(x => {
            if (bagCountBYCp.length === 0) {
                bagCountBYCp.push({ id: x.collectionPointID, value: x.bagCount });
            } else {
                var duplicateRec = bagCountBYCp.find(y => y.id === x.collectionPointID);

                if (duplicateRec) {
                    duplicateRec.value = checkIsUndefined(duplicateRec.value)
                        + checkIsUndefined(x.bagCount);
                } else {
                    bagCountBYCp.push({ id: x.collectionPointID, value: x.bagCount });
                }
            }
        });

        bagCountBYCp.forEach(x => {
            var record = mergedData.find(y => y.collectionPointID === x.id);

            if (record) {
                record.bagCount = x.value;
            }
        });

        return mergedData;
    }

    function checkIsUndefined(value) {
        if (value === undefined) {
            return 0;
        } else {
            return value;
        }
    }

    function createRecord(record) {
        var newRecord = {
            collectionPointID: record.collectionPointID,
            collectionPointName: record.collectionPointName,
            collectionPointName: record.collectionPointName,
            productCollectionID: record.productCollectionID
        };

        if (record.loftDeductionTempId !== null) {
            newRecord[record.loftDeductionTempId] = record.loftDeductionAmount;
            newRecord[record.deductionTypeName] = record.deductionTypeName;
        }

        return newRecord;
    }

    function calculateTotal(data) {
        var total = [];
        var bagCount = 0;

        data.forEach(x => {
            for (var property in x) {
                if (!isNaN(property)) {
                    total.push({ name: property, value: x[property] });
                }
            }
            bagCount = checkIsUndefined(bagCount) + checkIsUndefined(x.bagCount);
        });

        const res = Array.from(total.reduce(
            (m, { name, value }) => m.set(name, (m.get(name) || 0) + value), new Map
        ), ([name, value]) => ({ name, value }));

        setBagCount(bagCount);
        setFullTotalRow(res);
        return {
            res: res,
            bagCount: bagCount
        };
    }

    function generateCsvData(data, totalRowResult, contentResult) {

        var copyOfData = _.cloneDeep(data);
        var newRecord = { collectionPointName: "Total", bagCount: totalRowResult.bagCount }

        totalRowResult.res.forEach(x => {
            newRecord[x.name] = x.value === undefined ? (0).toFixed(2) : x.value.toFixed(2);
        });

        copyOfData.push(newRecord);

        setCsvData(copyOfData);
    }

    function generateTableInitializationData(data) {

        var copyOfInitialContentRownames = initialContentRownames;
        var copyOfInitialCsvHeaders = initialCsvHeaders;

        var deductionNames = [];
        var deductionIds = [];
        var csvFieldsData = [];

        data.forEach(x => {
            if (x.deductionTypeName !== null && x.loftDeductionTempId !== null) {
                deductionNames.push(x.deductionTypeName);
                deductionIds.push(x.loftDeductionTempId);
                csvFieldsData.push({ label: x.deductionTypeName, value: x.loftDeductionTempId })
            }
        });

        deductionNames = [...new Set(deductionNames)];
        deductionIds = [...new Set(deductionIds)];

        csvFieldsData = csvFieldsData.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.value === v.value)) === i);

        copyOfInitialContentRownames.splice(2, 0, ...deductionIds);

        copyOfInitialCsvHeaders.splice(2, 0, ...csvFieldsData);

        setCsvHeaders(copyOfInitialCsvHeaders);
        setDeductionIds(deductionIds);
        setContentRowNames(copyOfInitialContentRownames);
        setColumnNames(deductionNames);

        return {
            contentRowNames: copyOfInitialContentRownames,
            deductionNames: deductionNames,
            deductionIds: deductionIds,
            csvHeadersData: copyOfInitialCsvHeaders
        }
    }

    function createDataTable(contentResult, dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable({
                destroy: x === '#leafCollectionSummaryPdf' ? true : false,
                searching: x === '#leafCollectionSummaryPdf' ? false : true,
                paging: x === '#leafCollectionSummaryPdf' ? false : true,
                scrollX: false
            })
        });
    }

    function createFile() {
        var settings = {
            sheetName: 'LoftDeductionSummaryReport',
            fileName: 'Loft Deduction Summary Report',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionVariance,
            routeID: "0",
            fromDate: "",
            toDate: ""
        });
        setIsTableHide(true);
        setErrors("");
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate,
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Loft Deduction Summary Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionVariance.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionVariance.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionVariance.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="searchDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="searchDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionVariance)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <table id="leafCollectionSummary"
                                                    style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Route Name</th>
                                                            <th>Bag Count</th>
                                                            {columnNames.map((x, index) => {
                                                                return (
                                                                    <th scope="col" key={index}>{x}</th>
                                                                )
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContenForLoftSummaryReport
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th>Total</th>
                                                            <th style={{ textAlign: "right" }}>{bagCount}</th>
                                                            {deductionIds.map((x, i) => {
                                                                var res = fullTotalRow.find(y => y.name === x.toString());

                                                                if (res) {
                                                                    return (
                                                                        <th key={i} style={{ textAlign: "right" }}>
                                                                            {res.name === "bagCount" ? res.value : res.value.toFixed(2)}
                                                                        </th>
                                                                    );
                                                                }
                                                                else if (res === undefined) {
                                                                    return (
                                                                        <th index={i} style={{ textAlign: "right" }}>{(0).toFixed(2)}</th>
                                                                    );
                                                                }

                                                            })}
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pt-4">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Route Summary Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} columnNames={columnNames}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} deductionIds={deductionIds}
                                            fullTotalRow={fullTotalRow} bagCount={bagCount} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
